var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",class:_vm.className},'component',_vm.attributes,false),[_vm._l((_vm.element.child),function(child,index){return [(child.node === 'element')?_c('so-course-html',{key:index,attrs:{"element":child}}):_c('span',{key:index,domProps:{"innerHTML":_vm._s(child.text)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }